/**
 * SocialMedia component module.
 * @module shared/components/SocialMedia
 *
 */
import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {DescriptiveText} from '../../index';
import Image from '../Image';
import Row from '../Row';

const SocialMedia = props => {
  const {product, iconsMaxHeight, iconsMaxWidth} = props;
  const {brand} = product;

  return (brand.facebookLink || brand.twitterLink || brand.linkedInLink || brand.instagramLink) && <div>
    <DescriptiveText preset={'paragraph'} margin={props.helpTextMargin}>Connect with us on social media</DescriptiveText>
    <Row>
      {
        brand.facebookLink && <a
          target='_blank'
          rel='noopener noreferrer'
          href={brand.facebookLink}>
          <Image src='https://media.circleblack.com/misc/facebook_color.png'
                 maxHeight={iconsMaxHeight || '30px'}
                 maxWidth={iconsMaxWidth || '30px'}/>
        </a>
      }
      {
        brand.twitterLink && <a
          target='_blank'
          rel='noopener noreferrer'
          href={brand.twitterLink}>
          <Image src='https://media.circleblack.com/misc/twitter_color.png'
                 maxHeight={iconsMaxHeight || '30px'}
                 maxWidth={iconsMaxWidth || '30px'}/>
        </a>
      }
      {
        brand.linkedInLink && <a
          target='_blank'
          rel='noopener noreferrer'
          href={brand.linkedInLink}>
          <Image src='https://media.circleblack.com/misc/linkedin_color.png'
                 maxHeight={iconsMaxHeight || '30px'}
                 maxWidth={iconsMaxWidth || '30px'}/>
        </a>
      }
      {
        brand.instagramLink && <a
          target='_blank'
          rel='noopener noreferrer'
          href={brand.instagramLink}>
          <Image src='https://media.circleblack.com/misc/instagram_color.png'
                 maxHeight={iconsMaxHeight || '30px'}
                 maxWidth={iconsMaxWidth || '30px'}/>
        </a>
      }
    </Row>
  </div> || null;
};

const mapStateToProps = state => ({
  product: state.product,
});

export default connect(mapStateToProps, null)(SocialMedia);

SocialMedia.propTypes = {
  /**
   * The Product
   */
  product: PropTypes.shape({
    brand: PropTypes.object.isRequired,
  }).isRequired,
  /**
   * The Icon's maxHeight for display
   */
  iconsMaxHeight: PropTypes.string,
  /**
   * The Icon's maxWidth for display
   */
  iconsMaxWidth: PropTypes.string,
  /**
   * The margin of help text.
   */
  helpTextMargin: PropTypes.string,
};
